import DistressedListingCard from './DistressedListingCard.component';

export default DistressedListingCard;